import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { requestNotificationPermission } from "../utils/notifications";
import axiosInstance from "../api/axiosInstance";
import { useLocation } from "react-router-dom";
import LoadingAnimation from "../components/LoadingAnimation";



function LoginPage() {

const [phone, setPhone] = useState("");
const [password, setPassword] = useState("");
const [otp, setOtp] = useState("");

const [showPassword, setShowPassword] = useState(false);
const [error, setError] = useState("");
const [loading, setLoading] = useState(false);

const [otpSent, setOtpSent] = useState(false);
const [timer, setTimer] = useState(0);

const location = useLocation();
const navigate = useNavigate();

// ---------------- TIMER ----------------

useEffect(()=>{

if(timer<=0) return;

const interval = setInterval(()=>{

setTimer(prev=>prev-1);

},1000);

return ()=>clearInterval(interval);

},[timer]);



useEffect(() => {
  const handleBack = () => {
    navigate("/"); // 👈 landing page
  };

  window.history.pushState(null, "", window.location.pathname);
  window.addEventListener("popstate", handleBack);

  return () => {
    window.removeEventListener("popstate", handleBack);
  };
}, [navigate]);

// ---------------- ROLE REDIRECT ----------------

const redirectUser = async(data)=>{

localStorage.setItem("accessToken", data.access);
localStorage.setItem("refreshToken", data.refresh);
localStorage.setItem("userRole", data.role);

axiosInstance.defaults.headers.common[
"Authorization"
] = `Bearer ${data.access}`;

requestNotificationPermission();

if (data.role === "superadmin") navigate("/super-admin");
else if (data.role === "admin") navigate("/admin");
else if (data.role === "patient") navigate("/customer-dashboard");
else if (data.role === "pharmacist") navigate("/internal-pharmacist");
else if (data.role === "delivery") navigate("/delivery");
else if (data.role === "hospitalpharmacist") navigate("/hospital-pharmacist");

};
useEffect(() => {

  const token = localStorage.getItem("accessToken");
  const role = localStorage.getItem("userRole");

  if (token) {

    if (role === "superadmin") navigate("/super-admin");
    else if (role === "admin") navigate("/admin");
    else if (role === "patient") navigate("/customer-dashboard");
    else if (role === "pharmacist") navigate("/internal-pharmacist");
    else if (role === "delivery") navigate("/delivery");
    else if (role === "hospitalpharmacist") navigate("/hospital-pharmacist");

  }

}, [navigate]);
// ---------------- PASSWORD LOGIN ----------------

const handleLogin = async (e)=>{

e.preventDefault();

setLoading(true);
setError("");

try{

const resp = await axiosInstance.post("https://medical-backend-cgj8.onrender.com/api/login/",

{

phone,
password,

});

await redirectUser(resp.data);

}catch(err){

  const msg = err.response?.data?.error;

  if (msg === "Account has been deleted") {
    setError("Your account has been deleted. Contact support.");
    navigate("/delete-account"); // optional redirect
  } 
  else if (msg === "Your account is blocked") {
    setError("Your account is blocked. Contact admin.");
  } 
  else if (msg === "Account is deactivated") {
    setError("Your account is deactivated.");
  } 
  else {
    setError(msg || "Invalid phone or password");
  }

}
setLoading(false);

};
const normalizePhone = (phone) => {

let p = phone.trim();

if (p.startsWith("+91")) return p;

if (p.startsWith("91")) return "+" + p;

if (p.length === 10) return "+91" + p;

return p;

};
// ---------------- SEND OTP ----------------

const sendOTP = async()=>{

setError("");
setLoading(true);

try{

await axiosInstance.post("/send-otp/",{
phone: normalizePhone(phone),
});

setOtpSent(true);
setTimer(30);

}catch(err){

setError(err.response?.data?.error || "Failed to send OTP");

}

setLoading(false);

};

// ---------------- VERIFY OTP ----------------

const verifyOTP = async()=>{

setError("");
setLoading(true);

try{

const resp = await axiosInstance.post("/verify-otp/",{
phone: normalizePhone(phone),
otp,
});

await redirectUser(resp.data);

}catch(err){

setError(err.response?.data?.error || "Invalid OTP");

}

setLoading(false);

};

// ---------------- RESEND OTP ----------------

const resendOTP = async()=>{

setError("");
setLoading(true);

try{

await axiosInstance.post("/resend-otp/",{
phone: normalizePhone(phone),
});

setTimer(30);

}catch(err){

setError(err.response?.data?.error);

}

setLoading(false);

};

return (

<div style={styles.page}>


<div style={styles.card}>
    <h1 style={styles.logo}>
  <span style={{ color: "#ffffff" }}>Pharma</span>
  <span style={{ color: "#10b981" }}>Help</span>
</h1>

 {/* TRUST SECTION */}
      <div style={styles.trust}>
       
        <h2 style={styles.heading}>
  Your Trusted <span style={{ color: "#2a7ae4" }}>Online Pharmacy</span>
</h2>


        <div style={styles.location}>
        

        </div>
      </div>
<p style={styles.subtitle}>
Login to your Medical Delivery Account
</p>

{/* PHONE */}

<div style={styles.phoneContainer}>

  <span style={styles.phonePrefix}>
    +91
  </span>

  <input
    style={styles.phoneInputNew}
    placeholder="Enter phone number"
    value={phone}

    onChange={(e)=>{
      const value = e.target.value
        .replace(/\D/g, "")
        .slice(0,10);

      setPhone(value);
    }}

    onFocus={(e)=>{
      e.target.style.border = "1px solid #2a7ae4";
      e.target.style.boxShadow = "0 0 8px rgba(42,122,228,0.5)";
    }}

    onBlur={(e)=>{
      e.target.style.border = "1px solid #333";
      e.target.style.boxShadow = "none";
    }}
  />

</div>
{/* PASSWORD LOGIN */}

{!otpSent && (

<>

<div style={{position:"relative"}}>

<input
style={styles.input}
onFocus={(e)=>Object.assign(e.target.style, styles.inputFocus)}
onBlur={(e)=>e.target.style = styles.input}
type={showPassword ? "text":"password"}
placeholder="Password"
value={password}
onChange={(e)=>setPassword(e.target.value)}
/>

<span
style={styles.eyeIcon}
onClick={()=>setShowPassword(!showPassword)}

>

{showPassword ? <FaEyeSlash/> : <FaEye/>}

</span>

</div>
<div style={{ 
  display: "flex", 
  justifyContent: "space-between",
  marginBottom: "10px"
}}>

  <Link to="/delete-account" style={styles.smallLink}>
    🗑️ Delete Account
  </Link>

  <Link to="/forgot-password" style={styles.smallLink}>
    Forgot Password?
  </Link>

</div>
<button
style={{ ...styles.button, marginBottom: 0 }}
onMouseEnter={(e)=>e.target.style.transform="scale(1.03)"}
onMouseLeave={(e)=>e.target.style.transform="scale(1)"}
onClick={handleLogin}
disabled={loading}
>

{loading ? <LoadingAnimation small /> : "Login →"}

</button>










</>

)}

{/* OTP SECTION */}

{otpSent && (

<>

<input
style={styles.input}
onFocus={(e)=>Object.assign(e.target.style, styles.inputFocus)}
onBlur={(e)=>e.target.style = styles.input}
placeholder="Enter OTP"
value={otp}
onChange={(e)=>setOtp(e.target.value)}
/>

<button
style={{ ...styles.button, marginBottom: 14 }}
onMouseEnter={(e)=>e.target.style.transform="scale(1.03)"}
onMouseLeave={(e)=>e.target.style.transform="scale(1)"}
onClick={verifyOTP}
disabled={loading}
>

{loading ? <LoadingAnimation small /> : "Verify OTP"}

</button>

<button
style={styles.resendBtn}
disabled={timer>0}
onClick={resendOTP}

>

{timer>0 ?

`Resend OTP in ${timer}s`

:

"Resend OTP"

}

</button>

</>

)}

{error && <p style={{color:"red"}}>{error}</p>}

<div style={styles.signupCard}>
  <p style={styles.signupHeading}>
    New to PharmaHelp?
  </p>

  <Link
    to="/signup-customer"
    style={styles.signupButton}
  >
    🚀 Create Account
  </Link>

  <p style={styles.signupNote}>
    Fast signup • Secure orders • Home delivery
  </p>
</div>


 {/* FOOTER */}
<div style={{...styles.footer, marginTop:5}}>
  <Link to="/about" style={styles.link}>About</Link>
  {" • "}
  <Link to="/contact" style={styles.link}>Contact</Link>
  {" • "}
  <Link to="/privacy" style={styles.link}>Privacy</Link>

  <p style={{ marginTop: 8 }}>© PharmaHelp</p>
</div>
</div>

</div>

);

}

const styles = {

page:{
height:"100vh",
display:"flex",
justifyContent:"center",
alignItems:"center",
background:"radial-gradient(circle at top,#0f172a,#020617)", // 🔥 BLACK BG
},

logo: {
  fontSize: "42px",
  fontWeight: "800",
  letterSpacing: "-1px",
  marginBottom: 6,
},


phoneWrapper:{
  display:"flex",
  alignItems:"center",
  marginBottom:"10px",
},

countryCode:{
  padding:"12px",
  background:"#111827",
  border:"1px solid #333",
  borderRight:"none",
  borderRadius:"8px 0 0 8px",
  color:"#fff",
  fontSize:14,
},

phoneInput:{
  width:"100%",
  padding:"12px",
  border:"1px solid #333",
  borderRadius:"0 8px 8px 0",
  background:"#0f172a",
  color:"#fff",
  outline:"none",
  transition:"0.3s",
},	
phoneContainer:{
  position:"relative",
  marginBottom:"10px",
  width:"100%",
},
phonePrefix:{
  position:"absolute",
  left:"12px",
  top:"50%",
  transform:"translateY(-50%)",
  color:"#aaa",
  fontSize:14,
  zIndex:1,
},
tagline: {
  color: "#94a3b8",
  fontSize: "13px",
  marginTop: "-5px",
  marginBottom: "12px",
},
phoneInputNew:{
  width:"100%",
  padding:"12px 12px 12px 45px",
  borderRadius:"20px",
  border:"1px solid #333",
  background:"#0f172a",
  color:"#fff",
  outline:"none",
  transition:"0.3s",
  boxSizing:"border-box",
},
heading:{
  fontSize:20,
  fontWeight:"600",
  color:"#fff",
  marginBottom:6,
},

smallLink:{
  fontSize:13,
  color:"#bbb",
  textDecoration:"none",
},

mainLink:{
  color:"#2a7ae4",
  fontWeight:"500",
  textDecoration:"none",
  marginLeft:5,
},

signupText:{
  marginTop:14,
  fontSize:13,
  color:"#ccc",
},

card:{
  background:"rgba(17,24,39,0.6)",
  backdropFilter:"blur(12px)",
  border:"1px solid rgba(255,255,255,0.08)",
  padding:10,
  borderRadius:16,
  textAlign:"center",
  width:300,
  boxShadow:"0 20px 60px rgba(0,0,0,0.7)",
},

title:{
color:"#fff",
fontSize:18,
marginBottom:5,
},

subtitle:{
marginBottom:15,
fontSize:13,
color:"#aaa",
},

input:{
  width:"100%",
  padding:"12px",
  marginBottom:"10px",
  borderRadius:"20px",
  border:"1px solid #333",
  background:"#0f172a",
  color:"#fff",
  outline:"none",
  transition:"0.3s",
},

inputFocus:{
  border:"1px solid #2a7ae4",
  boxShadow:"0 0 8px rgba(42,122,228,0.5)"
},
orText:{
  margin: "10px 0",
  color: "#aaa",
  fontSize: 13,
  letterSpacing: 1,
},
button:{
  width:"100%",
  padding:"12px",
  background:"linear-gradient(135deg,#2a7ae4,#1d4ed8)",
  border:"none",
  borderRadius:"10px",
  color:"#fff",
  fontSize:15,
  cursor:"pointer",
  transition:"all 0.3s ease",
},

otpButton:{
  width:"100%",
  padding:"12px",
  background:"linear-gradient(135deg,#16a34a,#15803d)",
  color:"#fff",
  border:"none",
  borderRadius:"10px",
  cursor:"pointer",
  fontSize:15,
  fontWeight:"500",
  transition:"0.3s",
},

resendBtn:{
  marginTop:10,
  background:"none",
  border:"none",
  color:"#2a7ae4",
  cursor:"pointer",
  fontSize:13,
  opacity:0.9,
},

eyeIcon:{
position:"absolute",
right:10,
top:"50%",
transform:"translateY(-50%)",
cursor:"pointer",
color:"#aaa"
},

trust: {
textAlign: "center",
marginBottom: 5,
color:"#ccc",
fontSize:12,
},

footer: {
textAlign: "center",
marginTop: 5,
fontSize: 12,
color: "#888"
},

link:{
color:"#2a7ae4",
textDecoration:"none",
fontSize:12,
},
signupCard:{
  marginTop:0,
  padding:16,
  borderRadius:12,
  background:"rgba(255,255,255,0.04)",
  border:"1px solid rgba(255,255,255,0.08)",
},

signupHeading:{
  color:"#fff",
  fontSize:15,
  fontWeight:"600",
  marginBottom:10,
},

signupButton:{
  display:"block",
  width:"100%",
  padding:"12px",
  boxSizing:"border-box",
  borderRadius:"10px",
  background:"linear-gradient(135deg,#16a34a,#15803d)",
  color:"#fff",
  textDecoration:"none",
  fontWeight:"600",
},

signupNote:{
  marginTop:10,
  color:"#94a3b8",
  fontSize:"12px",
},
};
export default LoginPage;
